import { render, staticRenderFns } from "./EditProfileCorporation.vue?vue&type=template&id=3dae71aa&scoped=true"
import script from "./EditProfileCorporation.vue?vue&type=script&lang=js"
export * from "./EditProfileCorporation.vue?vue&type=script&lang=js"
import style0 from "./EditProfileCorporation.vue?vue&type=style&index=0&id=3dae71aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae71aa",
  null
  
)

export default component.exports